// src/pages/SupportedModels.js
import React, { useEffect } from 'react';
import Layout from '../components/Layout';
import ModelList from '../SupportComp';
import translations from '../translations';
import { useMeta } from '../useMeta';

function SupportedModels({ language = 'en' }) {
  const t = translations[language] || translations['en'];
  const prefix = language === 'en' ? '' : `/${language}`;

  useMeta({
    title: `${t.supportedModels.title} | ERC Unlock`,
    description: language === 'en'
      ? 'Full list of 53 supported Toyota head unit models for ERC unlocking. Includes ND, NH, NS, NM and DS series navigation and audio units.'
      : undefined,
    canonical: `https://ercunlock.com${prefix}/supported-models`
  });

  useEffect(() => {
    document.documentElement.lang = language;
    document.documentElement.dir = language === 'ur' ? 'rtl' : 'ltr';
    document.title = `${t.supportedModels.title} | ERC Unlock`;
  }, [language, t.supportedModels.title]);

  return (
    <Layout language={language}>
      <div className="content-card">
        <h1>{t.supportedModels.title}</h1>
        <p className="subtitle">{t.supportedModels.description}</p>
        <ModelList />
      </div>
    </Layout>
  );
}

export default SupportedModels;
